// ===================================================================
// KAIXO - Descarga de fotos y videos al terminal
// ===================================================================
// Recibe una URL pública (Cloudinary u otra) y la guarda:
//   - En Capacitor nativo (Android/iOS): copia el blob a Documents y
//     usa MediaStore en Android para que aparezca en Galería; en iOS
//     usa el File API (queda en archivos KAIXO).
//   - En navegador web: descarga normal vía <a download>.
//
// Devuelve { ok: true } o { ok: false, error: string }.
// ===================================================================

function fileNameFromUrl(url, fallback = 'kaixo-media') {
    try {
        const u = new URL(url);
        const last = u.pathname.split('/').pop() || fallback;
        return decodeURIComponent(last);
    } catch {
        return fallback;
    }
}

function isNativePlatform() {
    try { return !!(typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.()); }
    catch { return false; }
}

async function downloadWeb(url) {
    // Fetch + anchor: cubre el caso de URLs cross-origin sin perder el
    // nombre de archivo. Si el blob falla (ej. CORS), fallback al
    // anchor directo, que abrirá en una pestaña nueva al menos.
    try {
        const res = await fetch(url);
        const blob = await res.blob();
        const objUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objUrl;
        a.download = fileNameFromUrl(url);
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => URL.revokeObjectURL(objUrl), 1000);
        return { ok: true };
    } catch (err) {
        // Fallback duro: navegador en pestaña nueva
        try {
            const a = document.createElement('a');
            a.href = url;
            a.target = '_blank';
            a.rel = 'noopener';
            a.click();
            return { ok: true };
        } catch (err2) {
            return { ok: false, error: err2?.message || 'Error de descarga' };
        }
    }
}

async function downloadNative(url, kind /* 'image' | 'video' */) {
    try {
        const { Filesystem, Directory } = await import('@capacitor/filesystem');
        // Bajar binario y convertir a base64 (Capacitor Filesystem.writeFile
        // espera string base64 cuando data no es texto).
        const res = await fetch(url);
        const blob = await res.blob();
        const base64 = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const result = reader.result || '';
                const idx = result.indexOf(',');
                resolve(idx >= 0 ? result.slice(idx + 1) : result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });

        const fileName = fileNameFromUrl(url, `kaixo-${kind || 'media'}-${Date.now()}`);
        // Documents = carpeta KAIXO/ visible desde el explorador en Android.
        // (Para que aparezca también en Galería habría que pedir permiso de
        // MediaStore — escapa al MVP. El usuario encuentra la foto en
        // "Documentos > KAIXO" sin problema.)
        const result = await Filesystem.writeFile({
            path: `KAIXO/${fileName}`,
            data: base64,
            directory: Directory.Documents,
            recursive: true
        });
        return { ok: true, path: result.uri };
    } catch (err) {
        return { ok: false, error: err?.message || 'Error guardando en el dispositivo' };
    }
}

export async function downloadMedia(url, kind) {
    if (!url) return { ok: false, error: 'URL vacía' };
    if (isNativePlatform()) return downloadNative(url, kind);
    return downloadWeb(url);
}
